export default "__VITE_ASSET__BzmA2ybD__"